import * as React from "react";
import Cursor from "./cursor";
import { usePresenceWithCursors } from "./use-cursors";

export default function OtherCursors({
  showChat = false,
}: {
  showChat: boolean;
}) {
  const { otherUserIds, myId } = usePresenceWithCursors((state) => ({
    otherUserIds: Array.from(state.otherUsers.keys()),
    myId: state.myId,
  }));
  const within = usePresenceWithCursors((state) => state.within);

  // Sort user IDs to ensure consistent ordering
  const sortedUserIds = React.useMemo(() => {
    return [...otherUserIds].sort();
  }, [otherUserIds]);

  const style = {
    position: (within === "window"
      ? "fixed"
      : "absolute") as React.CSSProperties["position"],
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "clip",
    pointerEvents: "none" as React.CSSProperties["pointerEvents"],
  };

  return (
    <div style={style}>
      {/* Render other users' cursors */}
      {sortedUserIds.map((id) => {
        return (
          <Cursor 
            key={id} 
            userId={id} 
            fill={"#00f"} // This prop is still available but chat color comes from cursorConfig
            showChat={showChat}
            isOwnCursor={false}
          />
        );
      })}
      
      {/* Render own cursor when myId exists */}
      {myId && (
        <Cursor 
          key={`own-${myId}`}
          userId={myId} 
          fill={"#00f"} 
          showChat={showChat}
          isOwnCursor={true}
        />
      )}
    </div>
  );
}